import { PropsWithChildren } from "react";
import CVAModal from "components/modals/common/CVAModal";
import { useAppDispatch } from "stores/hooks";
import { markUI } from "stores/ui/uiSlice";
import { useDisclosure } from "utils/hooks/useDisclosure";
const ModalMapLogic = ({
  name,
  children
}: PropsWithChildren<{
  name: string;
}>) => {
  const {
    isOpen,
    onClose,
    onOpen
  } = useDisclosure();
  const dispatch = useAppDispatch();
  return <>
      <div className='flex items-center justify-center'>
        <div className='btn btn-primary fixed bottom-3.5 z-[9] hidden h-12 px-2.5 shadow md:flex xl:hidden'>
          <button className=' disable_click items-center gap-2 p-2 ' onClick={onOpen}>
            Map
          </button>
        </div>
      </div>

      <CVAModal intent={"modal"} size={"fullScreen"} isOpen={isOpen} onClose={() => {
      onClose();
      dispatch(markUI({
        openedPropertyCardInMapBox: null
      }));
    }} data-sentry-element="CVAModal" data-sentry-source-file="ModalMapLogic.tsx">
        <header className='h-20 px-4 py-7 font-semibold'>{name}</header>
        {children}
      </CVAModal>
    </>;
};
export default ModalMapLogic;